import(/* webpackMode: "eager" */ "/var/lib/neoscriber/publish/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/var/lib/neoscriber/publish/node_modules/@fortawesome/fontawesome-pro/css/all.css");
;
import(/* webpackMode: "eager" */ "/var/lib/neoscriber/publish/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/node_modules/@mui/material/CssBaseline/CssBaseline.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/lib/neoscriber/publish/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/var/lib/neoscriber/publish/public/css/fonts.css");
;
import(/* webpackMode: "eager" */ "/var/lib/neoscriber/publish/public/images/favicon-16x16.png");
;
import(/* webpackMode: "eager" */ "/var/lib/neoscriber/publish/public/images/favicon-32x32.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/src/utils/theme-registry.tsx");
